import {
  Box, Button, TextField, Typography,
} from '@mui/material';
import React, {
  useCallback, useContext, useEffect, useMemo, useState,
} from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { toast } from 'react-toastify';
import GlobalLoader from 'Shared/GlobalLoader/GlobalLoader';
import axios from 'axios';
import ReferencialContext from 'Shared/ReferencialContext';
import useForm from 'Shared/Hooks/useForm';
import ConnectedStore from 'Shared/ConnectedStore';
import { useHistory } from 'react-router-dom';
import AutoCompleteCmp from 'Shared/Select/AutoCompleteCmp';
import useStyles from './style';
import {
  INIT_EXTRA_FILTERS, INIT_FILTERS, SearchList, SearchReferenceType,
} from './constants';
import Model from './Model';
import {
  defaultMessage,
  getArticles,
  getVehicules,
  getArticlesByCarFamily,
} from './ExternSearchServices';
import NodataMessage from './NodataMessage';
import ExternSearchReducer from './reducer';
import { Provider, initialState } from './context';
import VinExtraFilters from './VinExtraFilters';
import ResultByRef from './ResultArea/v1';
import useVehiculesCriteria from './useVehiculesCriteria';

let cancelToken;
const ExternSearch = ({ location }) => {
  const [type, setType] = useState(null);
  const [typeRef, setTypeRef] = useState(SearchReferenceType[0]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [articles, setArticles] = useState(null);
  const [filteredArticles, setFiltredArticles] = useState(null);
  const [articlesData, setArticlesData] = useState([]);
  const [filtredTecDocfamilies, setFiltredTecDocFamilies] = useState([]);
  const [filtredTecDocBrands, setFiltredTecDocBrands] = useState([]);
  const [vehicules, setVehicules] = useState([]);
  // const [resetIndex, setResetIndex] = useState(false);
  const [isNoArticle, setIsNoArticle] = useState(false);
  const [isNoProduct, setIsNoProduct] = useState(false);
  const {
    brands: brandsTecdoc,
    models,
    enginesCode,
    enginesType,
    fetchModels,
    updateBrandEngineCodeTypeIfNeeded,
  } = useVehiculesCriteria();
  const [page, setPage] = useState(1);
  const [size] = useState(10);
  const [productsCopima, setProductsCopima] = useState(null);
  const { values: valuesExtraVin, onChange: onChangeExtraVin } = useForm(INIT_EXTRA_FILTERS);
  const { values, onChange, setValues } = useForm(INIT_FILTERS);
  // const [refArticleFamilies, setRefArticleFamilies] = useState(null);
  const classes = useStyles();
  const {
    state: { referencial },
  } = useContext(ReferencialContext);

  const history = useHistory();
  // const [copimaFamilies, setCopimaFamilies] = useState(families);
  // const [copimaBrands, setCopimaBrands] = useState(brands);

  const getArticleData = useCallback(
    async (tecdocFamily, tecdocBrand, append = false, p = 1) => {
      if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel('Cancel');
      }
      cancelToken = axios.CancelToken.source();
      if ((search && search.length >= 2) || tecdocFamily || tecdocBrand) {
        setLoading(true);
        if (!append) {
          setArticles([]);
        }
        // setRefArticleFamilies(null);
        const carId = location.search.length > 4
          ? location.search.replace('?', '').split('&')[0].split('=')[1]
          : null;
        const familyCarId = location.search.length > 4
          ? location.search.replace('?', '').split('&')[1].split('=')[1]
          : null;
        try {
          const data = await getArticles(
            search,
            tecdocFamily?.genericArticleId,
            tecdocBrand?.map((tb) => tb.dataSupplierId),
            { cancelToken: cancelToken.token },
            typeRef?.value || 0,
            size,
            p,
            carId,
            familyCarId,
          );
          const articleList = !append
            ? data?.articles || []
            : [...articles, ...(data?.articles || [])];
          if (!append) {
            // setResetIndex((prev) => !prev);
            setPage(1);
          }
          setArticles(articleList);
          setArticlesData(data);
          setFiltredTecDocBrands(data?.dataSupplierFacets?.counts);
          if (location.search.replace('?', '').length < 2) {
            setFiltredTecDocFamilies(data.genericArticleFacets?.counts);
          }
          setIsNoArticle(articleList.length === 0);
        } catch (e) {
          if (e.message !== 'Cancel') {
            const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
            toast.error(statusLabel);
          }
        } finally {
          setLoading(false);
        }
      }
    },
    [
      search,
      typeRef,
      setArticles,
      articles,
      values,
      setFiltredTecDocBrands,
      page,
      size,
    ],
  );

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    if (search.length > 0) {
      if (queryParams.has('carId')) {
        queryParams.delete('carId');
        history.replace({
          search: queryParams.toString(),
        });
      }
      if (queryParams.has('familyId')) {
        queryParams.delete('familyId');
        history.replace({
          search: queryParams.toString(),
        });
      }
    }
  }, [search]);

  const handleChangeSelect = (event) => {
    if (event.target.name === 'tecdocBrand') {
      getArticleData(values.tecdocFamily, event.target.value);
    } else if (event.target.name === 'tecdocFamily') {
      getArticleData(event.target.value, values.tecdocBrand);
      onChange({ target: { name: 'tecdocBrand', value: null } });
    }
    onChange(event);
  };

  const nextPage = () => {
    if (articles?.length < articlesData?.totalMatchingArticles) {
      getArticleData(values.tecdocFamily, values.tecdocBrand, true, page + 1);
      setPage((prev) => prev + 1);
    }
  };
  const getArticleCarFamilyData = useCallback(
    async (carFamily) => {
      setLoading(true);
      try {
        const data = await getArticlesByCarFamily(carFamily);
        const articleList = data?.articles || [];
        // setResetIndex((prev) => !prev);
        setPage(1);
        setArticles(articleList);
        setArticlesData(data);
        setFiltredTecDocBrands(data?.dataSupplierFacets?.counts);
        setFiltredTecDocFamilies(data.genericArticleFacets?.counts);
        setIsNoArticle(articleList.length === 0);
        // setRefArticleFamilies(articleList.map((item) => item.articleNumber));
      } catch (e) {
        if (e.message !== 'Cancel') {
          const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
          toast.error(statusLabel);
        }
      } finally {
        setLoading(false);
      }
    },
    [],
  );
  useEffect(() => {
    const articleNumbers = articles?.map((a) => a.articleNumber) || [];
    setProductsCopima(
      referencial?.products?.filter((p) => p.iA && articleNumbers.includes(p.refT)),
    );
    const copimaArticleNumbers = productsCopima?.map((a) => a.refT) || [];
    setFiltredArticles(articles?.filter((p) => !copimaArticleNumbers.includes(p.articleNumber)));
  }, [articles, referencial?.products]);

  const getVehiculesData = useCallback(async () => {
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Cancel');
    }
    cancelToken = axios.CancelToken.source();
    if (search?.length >= 2 || valuesExtraVin.brand || valuesExtraVin.model) {
      setLoading(true);
      try {
        const vehiculeList = await getVehicules(
          { vin: search, brandId: valuesExtraVin.brand?.id, modelId: valuesExtraVin.model?.id },
          { cancelToken: cancelToken.token },
        );
        setVehicules(vehiculeList);
        updateBrandEngineCodeTypeIfNeeded(valuesExtraVin.brand, vehiculeList, onChangeExtraVin);
      } catch (e) {
        if (e.message !== 'Cancel') {
          const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
          toast.error(statusLabel);
        }
      } finally {
        setLoading(false);
      }
    }
  }, [search, valuesExtraVin]);

  useEffect(() => {
    getVehiculesData();
  }, [valuesExtraVin.brand, valuesExtraVin.model]);

  useEffect(() => {
    if (valuesExtraVin.brand) {
      fetchModels(valuesExtraVin.brand.id);
    }
  }, [valuesExtraVin.brand]);

  useEffect(() => {
    const filtredVehicules = vehicules.map((v) => {
      const matchesEngineCode = valuesExtraVin.engineCode
        ? v.engineCode === valuesExtraVin.engineCode : true;
      const matchesEngineType = valuesExtraVin.engineType
        ? v.engineType === valuesExtraVin.engineType : true;

      // Both conditions need to match or be skipped if empty
      return { ...v, hide: !(matchesEngineCode && matchesEngineType) };
    });
    setVehicules(filtredVehicules);
  }, [valuesExtraVin.engineType, valuesExtraVin.engineCode]);
  const handleChange = (event) => {
    setSearch(event.target.value);
  };
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (type?.value === 'reference') {
        getArticleData();
      }
      if (type?.value === 'vin') {
        getVehiculesData();
      }
      if (search !== '') {
        const checkFilters = (pro) => {
          const isBrandMatch = values.copimaBrand === null || pro.bId === values.copimaBrand.id;
          const isFamilyMatch = values.copimaFamily === null || pro.fId === values.copimaFamily.id;
          return isBrandMatch && isFamilyMatch;
        };
        const targetRef = typeRef?.value === 1 ? 'reference' : 'refT';
        const pos = referencial?.products?.filter(
          (p) => p.bId !== 'EN SOMMEIL' && p.iA
            && p[targetRef]?.toLocaleLowerCase().includes(search.toLocaleLowerCase())
            && checkFilters(p),
        );
        setProductsCopima(pos);
        /* if (pos) {
          const familyIds = pos.map((a) => a.fId).unique();
          const brandIds = pos.map((a) => a.bId).unique();
          setCopimaFamilies(families.filter((f) => familyIds.includes(f.id)));
          setCopimaBrands(brands.filter((f) => brandIds.includes(f.id)));
        } */
        setIsNoProduct(pos === null || pos?.length === 0);
        if (!event.reset) {
          setValues(INIT_FILTERS);
        }
      }
    }
  };
  const handleSearchClick = (reset) => {
    handleKeyDown({ key: 'Enter', reset });
  };
  /* useEffect(() => {
    handleSearchClick(true);
  }, [values.copimaFamily, values.copimaBrand]); */
  const onChangeSearchType = (value) => {
    setType(value);
    setSearch('');
  };
  const onChangeSearchTypeRef = (value) => {
    setTypeRef(value);
    setSearch('');
  };
  useEffect(() => {
    if (location.search) {
      getArticleCarFamilyData(location.search.replace('?', ''));
      onChangeSearchType(SearchList[1]);
    }
  }, [location.search]);
  const isNoData = !loading && isNoArticle && isNoProduct;
  const vinBrands = useMemo(() => {
    if (search && vehicules?.length > 0 && brandsTecdoc?.length > 0) {
      const manuIds = vehicules?.map((v) => v.manuId);
      return brandsTecdoc.filter((b) => manuIds.includes(b.id));
    }
    return brandsTecdoc;
  }, [search, vehicules, brandsTecdoc]);
  return (
    <>
      {loading && <GlobalLoader size="100vh" />}
      <div style={{ height: '100vh', overflowY: 'auto' }}>
        <Box style={{ padding: '30px 15px' }}>
          <Typography
            display="block"
            style={{
              font: 'normal normal 600 26px Montserrat',
              color: '#000000',
            }}
          >
            Recherche générale
          </Typography>
          <Typography
            display="block"
            style={{
              font: 'normal normal 500 20px/24px Montserrat',
              paddingTop: 8,
              paddingBottom: 18,
              color: '#000000',
              textTransform: 'capitalize',
            }}
          >
            Utilisez La Recherche générale Pour Obtenir Plus D’informations Sur Les Produits
          </Typography>

          <Box className={classes.filterZone}>
            <Box sx={{ display: 'flex' }}>
              <AutoCompleteCmp
                options={SearchList}
                onChange={(event, value) => onChangeSearchType(value)}
                value={type}
                size="small"
                getOptionLabel={(option) => option.label}
                // eslint-disable-next-line max-len
                filterOptions={(options, v) => options.filter((option) => option.label?.toLowerCase().includes(v.inputValue.toLowerCase()))}
                isPrimaryTheme
                style={{ marginRight: 16, maxWidth: 250, minWidth: 250 }}
                label="type de recherche"
              />
              {type === SearchList[1] && (
              <AutoCompleteCmp
                options={SearchReferenceType}
                onChange={(event, value) => onChangeSearchTypeRef(value)}
                value={typeRef}
                size="small"
                getOptionLabel={(option) => option.label}
                // eslint-disable-next-line max-len
                filterOptions={(options, v) => options.filter((option) => option.label?.toLowerCase().includes(v.inputValue.toLowerCase()))}
                isPrimaryTheme
                style={{ marginRight: 16, maxWidth: 250, minWidth: 250 }}
                label="type de référence"
              />
              )}
              <TextField
                classes={{ root: classes.filter }}
                style={{ flexGrow: 1 }}
                placeholder={`Chercher par ${type ? type?.label : ''}`}
                variant="outlined"
                size="small"
                value={search}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                inputProps={{
                  autoComplete: 'new-password', // disable autocomplete and autofill,
                  maxLength: 17,
                }}
                disabled={!type}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                InputProps={{
                  classes: { notchedOutline: classes.notched, input: classes.input },
                  startAdornment: <SearchIcon style={{ color: '#AFB0B2' }} />,
                }}
                InputLabelProps={{
                  classes: { root: classes.label },
                }}
              />
              <Button
                disabled={search === ''}
                onClick={() => handleSearchClick(false)}
                variant="contained"
                color="inherit"
                className={classes.searchBtn}
                endIcon={<SearchIcon />}
              >
                RECHERCHE
              </Button>
            </Box>

            {type === SearchList[0] && (
              <VinExtraFilters
                filters={valuesExtraVin}
                onChange={onChangeExtraVin}
                brands={vinBrands}
                models={models}
                enginesCode={enginesCode}
                enginesType={enginesType}
                vin={search}
              />
            ) }
          </Box>
          {type?.value === 'reference' && (isNoData
            ? <NodataMessage />
            : (
              <ResultByRef
                products={{ copima: productsCopima || [], tecdoc: filteredArticles || [] }}
                brands={filtredTecDocBrands}
                families={filtredTecDocfamilies}
                filters={values}
                onChangeFilter={handleChangeSelect}
                handleNextTecdocArticles={nextPage}
                totalTecdocArticles={articlesData?.totalMatchingArticles || 0}
              />
            )
          )}
          {type?.value === 'vin' && (
            <>
              <Typography
                style={{
                  marginTop: 33,
                  marginBottom: 25,
                  font: 'normal normal 600 26px Montserrat',
                  color: '#000000',
                }}
              >
                Choisissez un modèle
              </Typography>
              <Box style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                {vehicules.filter((v) => !v.hide).map((v) => (
                  <Model
                    key={v.carId}
                    carId={v.carId}
                    name={v.carName}
                    vin={search || `manuId-${v.manuId}`}
                    type={v.fuelType}
                    img={v.vehiculeImage}
                    manuId={v.manuId}
                    modelId={v.modelId}
                    beginYear={v.beginYearMonth}
                    fuelType={v.fuelType}
                    engineType={v.engineType}
                    engineCode={v.engineCode}
                  />
                ))}
              </Box>
            </>
          )}
        </Box>
      </div>
    </>
  );
};

export default ConnectedStore(ExternSearch, ExternSearchReducer, initialState, Provider);
